import { getCurrentEnvironmentName, getEnvFromHTMLByName } from '@sparkai/env'

export const env = {
  DEV: import.meta.env.DEV,
  MODE: import.meta.env.MODE,
  CURRENT_ENVIRONMENT: getCurrentEnvironmentName(),

  VITE_NO_CHECKOUT: import.meta.env.VITE_NO_CHECKOUT === 'true',
  DISABLE_HEALTH_CHECK: import.meta.env.DISABLE_HEALTH_CHECK === 'true',

  VITE_AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN ?? getEnvFromHTMLByName('AUTH0_DOMAIN'),
  VITE_AUTH0_MFA_DOMAIN: import.meta.env.VITE_AUTH0_MFA_DOMAIN ?? getEnvFromHTMLByName('AUTH0_MFA_DOMAIN'),
  VITE_AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID ?? getEnvFromHTMLByName('AUTH0_CLIENT_ID'),
  VITE_AUTH0_REDIRECT_URI:
    import.meta.env.VITE_AUTH0_REDIRECT_URI ?? getEnvFromHTMLByName('AUTH0_REDIRECT_URI'),
  VITE_AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE ?? getEnvFromHTMLByName('AUTH0_AUDIENCE'),
}
